// ----------------------------------------------------------------------------
// Snippet: Menu
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

// Scripts
import $ from 'jquery';

// Styles
import './_menu.scss';
import './_menu--dropdown.scss';

// -------------------------------------
// Hooks
// -------------------------------------

function openMenu(menu, focusItem) {
    closeAllMenus(menu.$dropdown);
    // open menu
    menu.$dropdown.addClass('js--isOpen');
    menu.$dropdown.children('.menu__link').attr('aria-expanded', 'true');

    if (! menu.$dropdown.hasClass('menu__item--footer')) {
        $('body').addClass('menu--isOpen');
    }

    // move focus
    focusItem.focus();
}

function closeMenu(submenu) {
    // close menu
    submenu.$parentDropdown.removeClass('js--isOpen');
    submenu.$parentDropdown.children('.menu__link').attr('aria-expanded', 'false');

    if (! submenu.$parentDropdown.hasClass('menu__item--footer')) {
        $('body').removeClass('menu--isOpen');
    }
}

function closeAllMenus(menuDropdown) {
    menuDropdown.removeClass('js--isOpen');
    menuDropdown.siblings().removeClass('js--isOpen');
    menuDropdown.children('.menu__link').attr('aria-expanded', 'false');
    menuDropdown.siblings().children('.menu__link').attr('aria-expanded', 'false');
}

function moveFocusTo(focusItem) {
    focusItem.focus();
}

function moveTabindex(menuDropdown, menuLink) {
    menuDropdown.parents('.menu__list').find('.menu__link').attr('tabindex', '-1');
    menuLink.attr('tabindex', '0');
}

function hoverMenu() {

    if (window.innerWidth >= 1024) {
        $('.menu__item--dropdown:not(.menu__item--dropdown--secondary):not(.js--bound)').addClass('js--bound').on('mouseenter mouseleave', allowHoverOnMenu)
    } else {
        $('.menu__item--dropdown:not(.menu__item--dropdown--secondary).js--bound').removeClass('js--bound').off('mouseenter mouseleave', allowHoverOnMenu)
    }
}

function allowHoverOnMenu(e) {

    e.preventDefault();
    if (e.type === 'mouseenter') {
        setTimeout(function(event){
            $('.menu__item--dropdown:not(.menu__item--dropdown--secondary)').removeClass('js--isOpen');
            $(e.currentTarget).addClass('js--isOpen');
        }, 0);

        if (! $(e.currentTarget).hasClass('menu__item--footer')) {
            if ($(e.currentTarget).parents('.header').length) {
                $('body').addClass('menu--isOpen');
            }
        }
    }
    if (e.type === 'mouseleave') {
        if( ! $(e.toElement).hasClass('header__nav-wrapper') ) {
            setTimeout(function(event){
                $(e.currentTarget).removeClass('js--isOpen');
            }, 0);

            if (! $(e.currentTarget).hasClass('menu__item--footer')) {
                $('body').removeClass('menu--isOpen');
            }
        }

        $('.header__nav-wrapper').on('click', function() {
            $(e.currentTarget).removeClass('js--isOpen');
        })
    }
}

function fixMenu() {
    if (window.innerWidth > 1024) {
        $('.menu__item--dropdown .menu__link').not('.menu__item--footer.menu__item--dropdown .menu__link').on('click', function() {
            var $dropdown = $(this).closest('.menu__item--dropdown');
            $dropdown.toggleClass('js--isFixed');
            if($dropdown.hasClass('js--isFixed')){
                $('body').addClass('menu--isFixed');
            } else {
                $('body').removeClass('menu--isFixed');
            }
            $('.menu__item--dropdown').not($dropdown).each(function() {
                $(this).removeClass('js--isFixed');
            });
        });
        
        $('body').on('click', function(e) {
            if(!$(e.target).hasClass('dropdown')) {
                $('.menu__item--dropdown').each(function() {
                    $(this).removeClass('js--isFixed');
                });
                $('body').removeClass('menu--isFixed');
            }
        });
    }
}

$(function() {
    $('body').on('click', function() {
        $(this).removeClass('menu--isOpen');
    })

    // Opens dropdowns
    $('.menu__item--dropdown .menu__link, .dropdown__mobile-back').on('click', function(e) {
        e.stopPropagation();
        // Store elements as an object

        var $dropdown = $(this).closest('.menu__item--dropdown');

        if ($dropdown.hasClass('js--isOpen')) {
            if (! $dropdown.hasClass('menu__item--footer')) {
                $('body').removeClass('menu--isOpen');
            }
        } else {
            if (! $dropdown.hasClass('menu__item--footer')) {
                $('body').addClass('menu--isOpen');
            }
        }

        if ($dropdown.siblings().hasClass('js--isOpen')) {
            $dropdown.siblings().removeClass('js--isOpen');
            $dropdown.addClass('js--isOpen');
        } else {
            $dropdown.toggleClass('js--isOpen');
        }

    });
    
    hoverMenu();
    fixMenu();
    $(window).on('resize', hoverMenu);


    $('.menu--header .menu__item .menu__link').on('keydown', function(e) {
        var menu = {
            $menuLink:          $(e.target),
            $menuItem:          $(e.target).closest('.menu__item'),
            $dropdownList:      $(e.target).closest('.dropdown__list'),
            $dropdown:          $(e.target).closest('.menu__item--dropdown'),
            $dropdownLink:      $(e.target).closest('.dropdown__link'),
        };

        if (e.type === 'keydown') {
            let key = e.key;
            if (key === "Tab") {
                closeAllMenus(menu.$dropdown);
            } else {
                // If not Tab
                let menuItem,
                menuItemLink,
                focusLink;

                switch(key) {
                    case 'Enter': // Enter
                        // Opens submenu and moves focus to first item in submenu
                        focusLink = menu.$dropdown.find('.dropdown__link').first();
                        openMenu(menu, focusLink);
                        break;
                    case ' ': // Space
                        // Opens submenu and moves focus to first item in submenu
                        e.preventDefault();
                        focusLink = menu.$dropdown.find('.dropdown__link').first();
                        openMenu(menu, focusLink);
                        break;
                    case 'ArrowLeft': // left
                        // Moves focus to the previous item in the menubar.
                        // If focus is on the first item, moves focus to the last item.
                        e.preventDefault();
                        menuItem = menu.$menuLink.parent().prev();
                        if (menuItem.length <= 0) {
                            menuItem = menu.$menuLink.parent().siblings().last();

                        }
                        menuItemLink = menuItem.children('.menu__link');
                        moveFocusTo(menuItemLink);
                        moveTabindex(menu.$menuItem, menuItemLink);

                        break;
                    case 'ArrowRight': // Right
                        // Moves focus to the next item in the menubar.
                        // If focus is on the last item, moves focus to the first item.
                        e.preventDefault();
                         menuItem = menu.$menuLink.parent().next();
                        if (menuItem.length <= 0) {
                            menuItem = menu.$menuLink.parent().siblings().first();

                        }
                         menuItemLink = menuItem.children('.menu__link');
                        moveFocusTo(menuItemLink);
                        moveTabindex(menu.$menuItem, menuItemLink);

                        break;
                    case 'ArrowUp': // Up
                        // Opens submenu and moves focus to last item in the submenu.
                        e.preventDefault();
                        focusLink = menu.$dropdown.find('.dropdown__link').last();
                        openMenu(menu, focusLink);
                        break;
                    case 'ArrowDown': // Down
                        // Opens submenu and moves focus to first item in the submenu.
                        e.preventDefault();
                        focusLink = menu.$dropdown.find('.dropdown__link').first();
                        openMenu(menu, focusLink);
                        break;
                    case 'Home': // Home
                        // 	Moves focus to first item in the menubar.
                        e.preventDefault();
                        menuItem = menuItem = menu.$menuLink.parent().siblings().first();
                        menuItemLink = menuItem.children('.menu__link');
                        moveFocusTo(menuItemLink);
                        moveTabindex(menu.$menuItem, menuItemLink);
                        break;
                    case 'End': // End
                        // Moves focus to last item in the menubar.
                        e.preventDefault();
                        menuItem = menuItem = menu.$menuLink.parent().siblings().last();
                        menuItemLink = menuItem.children('.menu__link');
                        moveFocusTo(menuItemLink);
                        moveTabindex(menu.$menuItem, menuItemLink);
                        break;
                    default: // Any other character?
                        // Moves focus to next item in the menubar having a name that starts with the typed character. If none of the items have a name starting with the typed character, focus does not move.
                        menu.$menuItem.siblings().each(function(index, menuItem) {
                            let menuLink = $(menuItem).children('.menu__link');
                            let firstChar = menuLink[0].innerText.charAt(0).toLowerCase();
                            if (key.toLowerCase() === firstChar) {
                                moveFocusTo(menuLink);
                                moveTabindex($(menuItem), menuLink);
                                return false;
                            }
                        })
                }
            }
        }
    });

    $('.dropdown__item .dropdown__link').on('keydown', function(e) {
        var submenu = {
            $menuLink:          $(e.target),
            $dropdown:          $(e.target).parent(),
            $parentDropdown:    $(e.target).parents('.menu__item'),
            $parentLink:        $(e.target).parents('.menu__item').children('.menu__link')
        };

        let key = e.key;
        if (key === "Tab") {
            closeAllMenus(submenu.$parentDropdown);
        } else {
            // If not Tab
            let menuItem,
            menuItemLink,
            focusLink;

            switch(key) {
                case 'Enter': // Enter
                    // Activates menu item, causing the link to be activated.
                    break;
                case ' ': // Space
                    // Activates menu item, causing the link to be activated.
                    e.preventDefault();
                    submenu.$menuLink[0].click();
                    break;
                case 'Escape':
                    // Closes submenu. Moves focus to parent menubar item.
                    closeMenu(submenu);
                    moveFocusTo(submenu.$parentLink);
                    break;
                case 'ArrowLeft': // left
                    // Moves focus to previous item in the main menubar. Wraps to last item in main menubar.
                    e.preventDefault();
                    menuItem = submenu.$parentDropdown.prev();
                    if (menuItem.length <= 0) {
                        menuItem = submenu.$parentDropdown.siblings().last();

                    }
                    menuItemLink = menuItem.children('.menu__link');
                    closeMenu(submenu);
                    moveFocusTo(menuItemLink);

                    break;
                case 'ArrowRight': // Right
                    // Moves focus to next item in the main menubar. Wraps to first item in main menubar.
                    e.preventDefault();
                    menuItem = submenu.$parentDropdown.next();
                    if (menuItem.length <= 0) {
                        menuItem = submenu.$parentDropdown.siblings().first();
                    }
                    menuItemLink = menuItem.children('.menu__link');
                    closeMenu(submenu);
                    moveFocusTo(menuItemLink);

                    break;
                case 'ArrowUp': // Up
                    // Moves focus to previous item in the submenu.
                    // If focus is on the first item, moves focus to the last item.
                    e.preventDefault();
                    menuItem = submenu.$dropdown.prev();
                    if (menuItem.length <= 0) {
                        menuItem = submenu.$dropdown.siblings().last();
                    }
                    menuItemLink = menuItem.children('.dropdown__link');
                    moveFocusTo(menuItemLink);
                    break;
                case 'ArrowDown': // Down
                    // Moves focus to the next item in the submenu.
                    // If focus is on the last item, moves focus to the first item.
                    e.preventDefault();
                    menuItem = submenu.$dropdown.next();
                    if (menuItem.length <= 0) {
                        menuItem = submenu.$dropdown.siblings().first();
                    }
                    menuItemLink = menuItem.children('.dropdown__link');
                    moveFocusTo(menuItemLink);
                    break;
                case 'Home': // Home
                    // 	Moves focus to the first item in the submenu.
                    e.preventDefault();
                    menuItem = submenu.$dropdown.siblings().first();
                    menuItemLink = menuItem.children('.dropdown__link');
                    moveFocusTo(menuItemLink);
                    break;
                case 'End': // End
                    // Moves focus to the last item in the submenu.
                    e.preventDefault();
                    menuItem = submenu.$dropdown.siblings().last();
                    menuItemLink = menuItem.children('.dropdown__link');
                    moveFocusTo(menuItemLink);
                    break;
                default: // Any other character?
                    e.preventDefault();
                    // Moves focus to next item in the submenu having a name that starts with the typed character. If none of the items have a name starting with the typed character, focus does not move.
                    submenu.$dropdown.siblings().each(function(index, menuItem) {
                        let menuLink = $(menuItem).children('.dropdown__link');
                        let firstChar = menuLink[0].innerText.charAt(0).toLowerCase();
                        if (key.toLowerCase() === firstChar) {
                            moveFocusTo(menuLink);
                            moveTabindex($(menuItem), menuLink);
                            return false;
                        }
                    })
            }
        }
    });


    $('.menu__item--dropdown .menu__link').on('click', function(event) {
        event.preventDefault();
    });



    $('.mega-nav .dropdown__item--column-first .dropdown__item:not(.dropdown__item--image)').on('mouseenter', function(event) {
        let dropdownLink = $(this).find('.dropdown__link');
        let dropdownLinkImage = dropdownLink.data('collection');
        let dropdownLinkText = dropdownLink.data('collection-title');

        if ( dropdownLinkImage != '') {
            let collectionImage = $('.collection-image').find('.collection-image__image');
            let collectionText = $('.collection-image').find('.collection-image__title');

            collectionImage.attr("src", dropdownLinkImage);
            collectionText.text(dropdownLinkText);

            if(dropdownLinkText.length) {

            }

            $('.collection-image').css({'display':'grid', 'z-index': '5'});
        }else {
            $('.collection-image').css({'display': 'none', 'z-index': '-1'});
        }

    });

    $('.mega-nav .dropdown__item .dropdown__item:not(.dropdown__item--image)').on('mouseleave', function(event) {
        $('.collection-image').css({'display': 'none', 'z-index': '-1'});
    });
});
